import {
    CITY_FILTER,
    CATEGORY_FILTER,
    DROP_FILTER_OPEN,
    SET_WHERE_FILTER,
    SET_KIND_FILTER,
    SET_DATE_FILTER,
    SET_KEYWORD_FILTER,
    TOTAL_EVENTS,
    FILTERED_EVENTS_RETRIEVED,
    FESTIVAL_EVENT_RETRIEVED,
    END_FILTERED_LOAD,
    START_FILTERED_LOAD,
    SET_NEW_LIMIT,
    SINGLE_EVENT_RETRIEVED,
    PROMOTED_EVENTS_RETRIEVED,
    SEARCH_SUGGESTIONS,
    PLACE_RETRIEVED,
    BANNERS,
    TOGGLE_MENU,
    TOGGLE_MODAL,
    LOGGED_IN_STATUS,
    PROFILE_FETCHED,
    TOGGLE_MODAL_TYPE,
    RESET_LINK_SENT,
    STATIC_PAGE_RETRIEVED,
    PILETILEVI_TOP,
    RECENT_EVENTS,
    SET_ALL_FILTERS,
    LOGIN_ERROR,
} from '../action-types';
import store from '../store';
import {
    ajaxRequestResetLink,
    fetchCities,
    getEvents,
    fetchCategories,
    fetchTotal,
    getSingleEvent,
    getPromoted,
    fetchPlace,
    fetchBanners,
    sendLogin,
    getProfile,
    doLogout,
    requestResetLink,
    requestStaticPage,
    sendFbLogin,
    requestPiletiLeviTop,
    getRecent
} from './requests';
import { LIMIT_STEP } from '../../constants';



export const getList = (filter=null) => async dispatch => {
    const cities = await fetchCities(filter)
    dispatch({ type: CITY_FILTER, payload: cities });
};

export const getTotal = () => async dispatch => {
    const total = await fetchTotal()
    dispatch({ type: TOTAL_EVENTS, payload: total });
};

export const getCategories = (filter=null) => async dispatch => {
    const cities = await fetchCategories(filter)
    dispatch({ type: CATEGORY_FILTER, payload: cities });
};

export const openDropDown = (type) => {
    return {
        type: DROP_FILTER_OPEN,
        payload: {dropDownShow: !!type, type}
    }
}


export const setWhereFilter = (internalUrl) => async dispatch => {
    // logic to make request
    dispatch(getFiltered({where: internalUrl, start: 0}));
    dispatch ({
        type: SET_WHERE_FILTER,
        payload: internalUrl,
    })
}

export const setKindFilter = (category) => async dispatch => {
    // logic to make request
    dispatch(getFiltered({kind: category, start: 0 }));
    dispatch ({
        type: SET_KIND_FILTER,
        payload: category,
    })
}

export const setDateFilter = (dateFilter) => async dispatch => {
    dispatch(getFiltered({date: dateFilter, start: 0 }));
    dispatch ({
        type: SET_DATE_FILTER,
        payload: dateFilter,
    })
}

export const setKeywordFilter = (keyword) => async dispatch => {
    dispatch(getFiltered({keyword: keyword, start: 0 }));
    dispatch ({
        type: SET_KEYWORD_FILTER,
        payload: keyword,
    })
}

export const setAllFilters = (filters) => async dispatch => {
    dispatch(getFiltered(filters));
    dispatch ({
        type: SET_ALL_FILTERS,
        payload: filters,
    })
}

export const getSuggestions = (term) => async dispatch => {
    const items = store.getState().filters
    const newFilter = {...items, ...{keyword: `&sw=${term}`, start: 0, limit: 6}}
    const result = await getEvents(newFilter, true);


    if (!result) {
        dispatch({ type: SEARCH_SUGGESTIONS, payload: {total:0, events: []} });
    }
    dispatch ({
        type: SEARCH_SUGGESTIONS,
        payload: result.events,
    })
}

export const loadMoreItems = () => async dispatch => {
    const filters = store.getState().filters
    const start = filters.start + LIMIT_STEP
    dispatch(getFiltered({start}));
    dispatch ({
        type: SET_NEW_LIMIT,
        payload: start,
    })
}


export const getFiltered = (filter) => async dispatch => {
    const items = store.getState().filters
    const newFilter = {...items, ...filter}

    let events = await getEvents(newFilter);
    if (filter.start > 0) {
        const { filteredEvents } = store.getState();
        events.events = [ ...filteredEvents.events, ...events.events ]
    }

    dispatch(endFilteredLoad());
    dispatch({ type: FILTERED_EVENTS_RETRIEVED, payload: events });


}

export const getPromotedEvents = () => async dispatch => {
    const promoted = await getPromoted();
    if (!promoted) {
        dispatch({ type: PROMOTED_EVENTS_RETRIEVED, payload: null });
    }
    dispatch({ type: PROMOTED_EVENTS_RETRIEVED, payload: promoted });
}

export const getEvent = (internalUrl) => async dispatch => {
    const event = await getSingleEvent(internalUrl);
    if (!event) {
        dispatch({ type: SINGLE_EVENT_RETRIEVED, payload: null });
    }
    dispatch({ type: SINGLE_EVENT_RETRIEVED, payload: event });
}

export const getFestivalEvent = (internalUrl) => async dispatch => {
    const event = await getSingleEvent(internalUrl);
    if (!event) {
        dispatch({ type: FESTIVAL_EVENT_RETRIEVED, payload: null });
    }
    dispatch({ type: FESTIVAL_EVENT_RETRIEVED, payload: event });
}

export const startFilteredLoad = () => {
    return {
        type: START_FILTERED_LOAD,
        payload: { loading: true }
    }
}

export const endFilteredLoad = () => {
    return {
        type: END_FILTERED_LOAD,
        payload: { loading: false }
    }
}

export const getPlace = (internalUrl) => async dispatch => {
    const place = await fetchPlace(internalUrl);
    dispatch({
        type: PLACE_RETRIEVED,
        payload: place
    });
}

export const getBanners = () => async dispatch => {
    const banners = await fetchBanners();

    dispatch({
        type: BANNERS,
        payload: {
            banners,
            total: banners ? banners.length : 0
        }
    });
}

export const toggleMenu = (state = null) => dispatch => {
    if (state !== null) {
        dispatch({type: TOGGLE_MENU, payload: state})
    } else {
        const opened = store.getState().menuState
        dispatch({type: TOGGLE_MENU, payload: !opened})
    }
}

export const toggleModal = () => dispatch => {

    const shown = store.getState().showModalWindow
    dispatch({type: TOGGLE_MODAL, payload: !shown})
}

export const toggleModalType = (type) => dispatch => {
    dispatch({type: TOGGLE_MODAL_TYPE, payload: {type}})
}


export const actionLogin = (data) => async dispatch => {
    const result = await sendLogin(data);
    
    if (result) {
        dispatch(actionProfile());
    } else {
        dispatch(actionLoginError('Vale kasutajanimi või parool!'));
    }
    dispatch({
        type: LOGGED_IN_STATUS,
        payload: {
            loggedIn: result
        }
    })
}

export const actionFbLogin = (data) => async dispatch => {
    const result = await sendFbLogin(data);
    if (result) {
        dispatch(actionProfile());
    }
    dispatch({
        type: LOGGED_IN_STATUS,
        payload: {
            loggedIn: result
        }
    })
}

export const actionProfile = () => async dispatch => {
    const resp = await getProfile();
    const  payload = {
        username: null,
        city: null
    }

    const { code, data } = resp

    if (code && code === 1 && data) {
        payload.username = resp.data.username;
        payload.city = data.city ? data.city.internalurl : '';
    }
    //console.log('pay', payload);
    dispatch({
        type: PROFILE_FETCHED,
        payload
    })
}

export const actionLoginError = (message = '') => async dispatch => {
    dispatch({
        type: LOGIN_ERROR,
        payload: {
            message
        }
    })
}

export const actionLogout = () => async dispatch => {
    const resp = await doLogout()
    dispatch({
        type: LOGGED_IN_STATUS,
        payload: {
            loggedIn: false
        }
    })
    dispatch({
        type: PROFILE_FETCHED,
        payload: {
            username: null
        }
    })
}


export const actionSendLink = (data) => async dispatch => {
    const result = await ajaxRequestResetLink(data)

    const message = result ? 'Parooli meeldetuletus saadetud!' : 'Ebaõnnestus. Palun proovi uuesti või kontakteeru meiega!';
    dispatch({
        type: RESET_LINK_SENT,
        payload: {
            message,
            code: result,
        }
    })
}

export const actionSendLinkReset = () => dispatch => {
    dispatch({
        type: RESET_LINK_SENT,
        payload: {
            message: '',
            code: 0,
        }
    })
}

export const getPageData = (page) => async dispatch => {
    const result = await requestStaticPage(page);
    dispatch({
        type: STATIC_PAGE_RETRIEVED,
        payload: {page:result}
    })
}

export const getPiletiLeviTop = () => async dispatch => {
    const result = await requestPiletiLeviTop();
    const { data } = result
    const payload = {
        total: data ? data.top10.length : 0,
        events: data ? data.top10.map(e => e) : []
    }
    dispatch({
        type: PILETILEVI_TOP,
        payload,
    })
}

export const getLatestEvents = (start=0, limit=10) => async dispatch => {
    const result = await getRecent(start, limit);
    const { recentEvents } = store.getState();
    if (recentEvents.events.length) {
        result.events = [...recentEvents.events, ...result.events]
    }
    dispatch({
        type: RECENT_EVENTS,
        payload: result,
    })
}
